import {Component, EventEmitter, Input, OnInit, Output, Renderer2, OnDestroy} from '@angular/core';
import * as globals from '../settings';
import {LotteriesService} from '../lotteries.service';
import {Event, Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {UserService} from '../_services/user.service';
import {CartService} from '../_services/cart.service';
import {CurrencyService} from '../_services/currency.service';
import {GetPaymentMethodsService} from '../shared/paymentMethod/get-payment-methods.service';
import {PaystackSupportService} from '../shared/paystack-support.service';

@Component({
    selector: 'app-scratch-checkout',
    templateUrl: './scratch-checkout.component.html',
    styleUrls: ['./scratch-checkout.component.scss']
})
export class ScratchCheckoutComponent implements OnInit, OnDestroy {
    @Input() tickets;
    @Input() id;
    @Input() myScratch;
    @Input() runModal;
    tmpRunModal: number;
    gotLotteries: boolean;
    showMore: number;
    totalPrice: any;
    paymentModal: boolean;
    paymentMethods: any;
    addNewMethod: boolean;
    selected_method: any;
    chosenOption: any;
    chosenOptionName: any;
    selected_method_class: any;
    selected_method_class_brand: any;
    canPay: boolean;
    discount: any;
    bundles: any[];
    onlyFew: boolean;
    user: any;
    isMobile: boolean;
    isLoadingButton: boolean;
    balancePay: any;
    error50: boolean;
    errorDefault: boolean;
    additional: string;
    error42: boolean;
    error68: boolean;
    error69: boolean;
    error81: boolean;
    error75: boolean;
    error74: boolean;
    error94: boolean;
    error90: boolean;
    error95: boolean;
    error10008: boolean;
    errorParams: string;
    errorReason: string;
    purchaseAnyway: string;
    claim: boolean;
    paymentFailed: any;
    originalPrice: any;
    discountPrice: any;
    modalSize: any;
    existingMethod: boolean;
    cartItems: any;
    isEmptyCart: boolean;
    rendered: boolean;
    firstTime: boolean;
    checkDiscount: boolean;
    discountAmount: any;
    promoPercent: any;
    discountToShow: any;
    updateTheCart: any;
    showSelected: boolean;
    showApply: any;
    showNotValid: any;
    showLang: any;
    cartPrice: number;
    toRemove: any;
    removeFromCart: boolean;
    successPayment: boolean;
    haveBalance: boolean;
    n: any;
    selected_method_show_name: any;
    closeMiniCheckout: Subscription;
    closeMiniCheckoutSubscription: Subscription;
    getBalanceC: Subscription;
    myBalance: any;
    delay: boolean;
    addPMOpenSub: Subscription;
    addPMOpen: boolean;
    index: number;
    changedCurrency: Subscription;
    addToCart: Subscription;
    currency: any;
    gpmData: any;
    getPaymentMethodsSub: Subscription;
    minusBalanceValue_forTotal: number;
    minusBalanceValue_forDiscount: number;
    afterComma = globals.afterComma;
    devMode = globals.devMode;
    showDiscount: boolean;
    usePaystack: boolean;
    paymentSuccess: boolean;
    brand = globals.brand;
    referenceId: string;

    constructor(public lotteryService: LotteriesService,
                public subscriptionsService: SubscriptionsService,
                public userService: UserService,
                private router: Router,
                private renderer: Renderer2,
                public cartService: CartService,
                private translate: TranslateService,
                public currencyService: CurrencyService,
                public getpmService: GetPaymentMethodsService,
                public paystackSupport: PaystackSupportService) {

        this.getLang();
        this.addToCart = this.subscriptionsService.getAddToCartScratch().subscribe(data => {
            this.playThisScratch(data.amountArray[data.tickets], data.id);
        });
        this.closeMiniCheckoutSubscription = this.subscriptionsService.getCloseMiniCheckout().subscribe(register => {
            this.closeMiniCheckout = register;
            if (this.closeMiniCheckout
              && this.router.url !== '/de/cart'
              && this.router.url !== '/vi/cart'
              && this.router.url !== '/id/cart'
              && this.router.url !== '/en/cart'
            ) {
                this.paymentModal = false;
                this.endMiniCheckout();
                this.successPayment = true;
            } else if (this.closeMiniCheckout) {
                this.paymentModal = false;
                this.endMiniCheckout();
                this.router.navigate(['/' + this.showLang, 'cart', 'payment-success']);
            }
        });
        this.delay = false;
        this.getBalanceC = this.subscriptionsService.getBalance().subscribe(balance => {
            this.myBalance = balance;
        });
        this.addPMOpenSub = this.subscriptionsService.getMiniCheckoutAddPM().subscribe(addPMOpen => {
            this.getPaymentMethods();
            this.addPMOpen = addPMOpen;
        });
        this.currency = this.currencyService.currency;
        this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
            if (currency) {
                this.currency = currency;
            }
        });

        this.getpmService.getPaymentMethods();

        this.getPaymentMethodsSub = this.subscriptionsService.getPaymentMethods().subscribe(gpm => {
            this.gpmData = gpm;
            this.balanceChecker();
            this.getPaymentMethods();
        });
    }

    // public getCloseMiniCheckout(event: Event) {
    //     this.closeMiniCheckout = event;
    // }

    ngOnInit() {
        this.paymentMethods = [];
        /* runCheckout observer: */
        setInterval(() => {
            if (this.tmpRunModal !== this.runModal && this.runModal > 0) {
                this.tmpRunModal = this.runModal;
                this.playThisScratch(this.tickets, this.id);
            }
        }, 500);


        let paystackIntervalTime = 100;
        const paystackInterval = setInterval(() => {
            if (paystackIntervalTime === 100) {
                paystackIntervalTime = 1000;
            }
            if (this.user && this.usePaystack === undefined) {
                this.paystackSupport.checkIfPaystack();
                clearInterval(paystackInterval);
            }
        }, paystackIntervalTime);

        this.canPay = true;
        this.existingMethod = true;
        this.balancePay = false;
        this.removeFromCart = false;
        this.index = 0;

        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.showLang = this.translate.currentLang;
        });
    }


    getLang() {
        const language = localStorage.getItem('pageLanguage');
        this.showLang = language;
        if (language !== null) {
            this.translate.use(language);
        } else {
            setTimeout(() => {
                this.getLang();
            }, 500);
        }
    }

    payWithExtClick() {
        if (this.selected_method !== 'none' && this.selected_method !== undefined) {
            this.canPay = true;
        } else {
            this.canPay = false;
        }
    }


    playThisScratch(tickets, val) {
        this.gotLotteries = false;
        const cart = localStorage.getItem('cart');
        const jsonCart = JSON.parse(cart);
        const userDataString = localStorage.getItem('playerDetails');
        const userDataJson = JSON.parse(userDataString);
        this.user = userDataJson;
        if (jsonCart !== null && userDataJson) {
            jsonCart.some((element) => {
                if (element.ProductType !== 'game' && element.ProductSubType !== 'games') {
                    return this.gotLotteries = true;
                }
            });
        }
        let memberId = '0';
        if (userDataJson) {
            memberId = userDataJson.MemberID;
        }
        const cartToSend = 'packageId[0]=' + val + '&TicketsCount[0]=' + tickets + '&currency=' + this.currency.Code;
        this.lotteryService
            .postData(globals.appDomain + '/cart/addSingleTicket/' +
                memberId + '/cartAddSingleTicket_scratchcard.json', this.resendCart(cartToSend))
            .subscribe(
                resp => {
                    this.subscriptionsService.emitToggleContent(false);
                    if (!resp.addCartMessage.ErrorID && resp.addCartMessage) {
                        this.myScratch = resp.addCartMessage.Cart.Packages;
                        if (resp.addCartMessage.Cart.OriginPrice) {
                            this.totalPrice = this.recalculatePriceForBalance(+resp.addCartMessage.Cart.OriginPrice, 'total');
                        }
                        if (resp.addCartMessage.Cart.Price) {
                            this.discountPrice = this.recalculatePriceForBalance(+resp.addCartMessage.Cart.Price, 'discount');
                        }
                        if (+resp.addCartMessage.Cart.OriginPrice === +resp.addCartMessage.Cart.Price) {
                            this.showDiscount = false;
                        } else {
                            this.showDiscount = true;
                        }
                        if (this.userService.userData) {
                            localStorage.setItem('cart', JSON.stringify(resp.addCartMessage.Cart.Packages));
                            this.cartService.mapPrice(resp.addCartMessage.Cart, false);
                        } else {
                            if (!this.cartItems) {
                                this.cartItems = resp.addCartMessage.Cart.Packages;
                            }
                            this.cartItems.forEach((element) => {
                                if (resp.addCartMessage.Cart && resp.addCartMessage.Cart.Packages) {
                                    for (let i = 0; i < resp.addCartMessage.Cart.Packages.length; i++) {
                                        if (((element.PackageID == resp.addCartMessage.Cart.Packages[i].PackageID) &&
                                            (element.Discount && element.Discount.IncentiveID))) {
                                            resp.addCartMessage.Cart.Packages[i].Discounts = {
                                                ['Incentive']: {
                                                    ['0']: element.Discount
                                                }
                                            };
                                            resp.addCartMessage.Cart.Packages[i].IsIncentive = true;
                                            resp.addCartMessage.Cart.Packages[i].IsDiscount = true;
                                            resp.addCartMessage.Cart.Packages[i].PackagePrice = element.PackagePrice;

                                        } else if (((element.PackageID == resp.addCartMessage.Cart.Packages[i].PackageID) &&
                                            (element.Discounts && element.Discounts.Incentive))) {
                                            if (element.Discounts.Incentive[0] != false && 'IncentiveID' in
                                                element.Discounts.Incentive[0]) {
                                                resp.addCartMessage.Cart.Packages[i].Discounts = element.Discounts;
                                                resp.addCartMessage.Cart.Packages[i].IsIncentive = true;
                                                resp.addCartMessage.Cart.Packages[i].PackagePrice = element.PackagePrice;
                                                resp.addCartMessage.Cart.Packages[i].IsDiscount = true;
                                            } else {
                                                resp.addCartMessage.Cart.Packages[i].IsIncentive = false;
                                                resp.addCartMessage.Cart.Packages[i].PackagePrice = element.PackagePrice;
                                            }
                                        }
                                    }
                                }
                            });
                            localStorage.setItem('cart', JSON.stringify(resp.addCartMessage.Cart.Packages));
                            this.cartService.mapPrice(resp.addCartMessage.Cart, false);
                        }
                        this.cartPrice = this.cartService.payable;
                        if (this.myScratch && this.myScratch.length) {
                            this.showMore = this.myScratch.length - 2;
                        } else {
                            this.showMore = 0;
                        }
                        if (this.gotLotteries) {
                            this.router.navigate(['/' + this.showLang, 'cart']);
                            this.subscriptionsService.emitToggleContent(true);
                        } else {
                            const userDataString3 = localStorage.getItem('playerDetails');
                            const userDataJson3 = JSON.parse(userDataString3);
                            this.user = userDataJson3;
                            if (userDataJson3) {
                                // this.totalPrice = 0;
                                this.getPaymentMethods();
                                this.paymentModal = true;
                            } else {
                                const cart2 = resp.addCartMessage.Cart.Packages;
                                this.subscriptionsService.updateCartItems(cart2);
                                this.subscriptionsService.emitIsCart(true);
                                this.subscriptionsService.emitRegisterOrLogin(true);
                            }
                        }
                        if (this.user) {
                            const user = JSON.parse(localStorage.getItem('playerDetails'));
                            const userBalance = +user.RealBalance;
                            if (userBalance >= +this.cartPrice) {
                                this.haveBalance = true;
                            } else {
                                this.haveBalance = false;
                            }
                        }
                        this.subscriptionsService.updateFinishedLoadingOnScratchHomepage(true);
                        setTimeout(() => {
                            this.delay = true;
                        }, 1500);
                    } else {
                        this.subscriptionsService.emitToggleContent(true);
                    }
                }
            );
    }

    getPaymentMethods() {
        this.index = 0;
        const result = this.gpmData || this.getpmService.gpm_tmp;
        if (result && result.message) {
            const methods = result.message.PaymentOptions;
            this.paymentMethods = methods;
            if ((!this.paymentMethods || !this.paymentMethods.length) && this.user && this.user.TotalBalance === '0.00') {
                this.addNewMethod = true;
            } else {
                this.addNewMethod = false;
            }
            if (this.paymentMethods) {
                this.paymentMethods.forEach((element) => {
                    element.selectValue = '&paymentOptionType=' + element.paymentMethodName +
                        '&paymentOptionId=' + element.userPaymentOptionId;
                    if (element.paymentMethodName === 'Card') {
                        element.selectDisplayName = element.upoData.ccCardNumber;
                        element.selectImageClass = element.upoData.brand;
                    } else {
                        element.selectDisplayName = element.paymentMethodDisplayName;
                        element.selectImageClass = element.paymentMethodName;
                    }
                    if (element.isDefault === true) {
                        this.selected_method = '&paymentOptionType=' + element.paymentMethodName +
                            '&paymentOptionId=' + element.userPaymentOptionId;
                        this.chosenOption = '&paymentOptionType=' + element.paymentMethodName +
                            '&paymentOptionId=' + element.userPaymentOptionId;
                        this.selected_method_class = element.paymentMethodDisplayName;
                        this.selected_method_class_brand = element.upoData ? element.upoData.brand : '';
                        this.selected_method_show_name = element;
                        this.chosenOptionName = element.selectDisplayName;
                    }
                    this.index++;
                });
                this.paymentMethods = this.paymentMethods.filter(paymentMethod => {
                    return paymentMethod.selectDisplayName;
                });
            }
            this.fuckingUndefinedFix();
        } else {
            setTimeout(() => {
                this.getPaymentMethods();
            }, 500);
        }
    }

    fuckingUndefinedFix() {
        if (this.paymentMethods === undefined) {
            setTimeout(() => {
                this.fuckingUndefinedFix();
            }, 500);
            // } else {
            // this.toggleBalancePay();
        }
    }

    toggleBalancePay() {
        setTimeout(() => {
            let gotBalance = true;
            if (this.paymentMethods) {
                if (this.paymentMethods.length) {
                    this.paymentMethods.forEach((element) => {
                        if (element.selectDisplayName === 'balance') {
                            gotBalance = false;
                            if (this.user.TotalBalance * 1 <= this.totalPrice * 1) {
                                this.paymentMethods.splice(this.paymentMethods.indexOf(element), 1);
                                const tempArray = [...this.paymentMethods];
                                this.paymentMethods = [];
                                this.paymentMethods = tempArray;
                                if (this.paymentMethods.length) {
                                    this.existingMethod = true;
                                } else {
                                    this.existingMethod = false;
                                }
                                return false;
                            } else {
                                if (this.paymentMethods && this.paymentMethods.length) {
                                    this.existingMethod = true;
                                }
                            }
                        }
                    });
                    if (gotBalance && this.user) {
                        if (+this.user.RealBalance >= +this.discountPrice) {
                            this.paymentMethods.unshift({
                                'paymentMethodName': 'balance',
                                'selectImageClass': 'balance',
                                'selectDisplayName': 'balance'
                            });
                            const tempArray = [...this.paymentMethods];
                            this.paymentMethods = [];
                            this.paymentMethods = tempArray;
                        }

                    }
                } else {
                    this.balanceChecker();
                }
            } else {
                this.balanceChecker();
            }
        }, 500);
    }

    balanceChecker() {
        if (this.user) {
            setTimeout(() => {
                if (+this.user.RealBalance >= +this.totalPrice && this.totalPrice !== '0.00' && this.totalPrice !== 0) {
                    const balance = this.paymentMethods.filter((elem) => {
                        return elem.selectDisplayName === 'balance';
                    });
                    if (balance.length === 0) {
                        this.paymentMethods.unshift({
                            'paymentMethodName': 'balance',
                            'selectImageClass': 'balance',
                            'selectDisplayName': 'balance'
                        });
                        this.index++;
                    }
                    const tempArray = [...this.paymentMethods];
                    this.paymentMethods = [];
                    this.paymentMethods = tempArray;
                    this.existingMethod = true;
                } else {
                    this.existingMethod = false;
                }
            }, 200);
        }
    }

    valueChanger(event) {
        if (event) {
            this.selected_method = '&paymentOptionType=' + event.paymentMethodName +
                '&paymentOptionId=' + event.userPaymentOptionId;
            this.chosenOption = '&paymentOptionType=' + event.paymentMethodName +
                '&paymentOptionId=' + event.userPaymentOptionId;
            this.chosenOptionName = event.selectDisplayName;
            this.selected_method_show_name = event;
            if (event.paymentMethodName === 'balance') {
                this.balancePay = true;
            } else {
                this.balancePay = false;
            }
        }
    }

    closeModal() {
        this.subscriptionsService.closeModalNow(true);
        setTimeout(() => {
            this.renderer.removeClass(document.body, 'modal-open');
            this.paymentModal = false;
            this.endMiniCheckout();
            this.subscriptionsService.emitToggleContent(true);
        }, 1500);
    }

    payWithBalanceClick() {
        this.canPay = true;
    }

    onSelectMethod(value) {
        this.selected_method = value;
        this.canPay = true;
    }

    onClickMethod(value, brand?) {
        this.selected_method_class = value;
        this.selected_method_class_brand = brand ? brand : '';
    }

    sendPayment() {
        let paymentMethod = '';
        const url = this.router.url;
        this.userService.checkStatus(this.userService.userData.Status).then(data => {
            if (data === 'noRedirect') {
                this.isLoadingButton = true;
                if (this.balancePay === true) {
                    this.additional = '&paymentOptionType=balance';
                    paymentMethod = 'balance';
                    this.selected_method = '';
                } else {
                    this.additional = '';
                }
                let body = '';
                const uri = this.router.url.split('?')[0];
                if (this.cartService.payable <= 0) {
                    this.selected_method = '&paymentOptionType=balance';
                    paymentMethod = 'balance';
                }
                if (this.selected_method.includes('&paymentOptionType=Card')) {
                    body = 'purchaseAnyway=' + this.purchaseAnyway + '&isGift=false&sessionId='
                        + this.user.sessionId + this.selected_method +
                        this.additional + '&apmCallbackSuccessUrl='
                        + globals.frontDomain + '/' + this.showLang + '/cart/payment-processing/' +
                        '&apmCallbackFailUrl=' + globals.frontDomain + '/' + this.showLang +
                        '/cart/payment-processing/';
                    localStorage.setItem('success3d', globals.frontDomain + '/' + this.showLang +
                        '/cart/payment-success');
                    localStorage.setItem('fail3d', globals.frontDomain + '/' + this.showLang + '/cart?paymentStatus=failed');
                } else {
                    body = 'purchaseAnyway=' + this.purchaseAnyway + '&isGift=false&sessionId='
                        + this.user.sessionId + this.selected_method +
                        this.additional + '&apmCallbackSuccessUrl='
                        + globals.frontDomain + '/' + this.showLang +
                        '/cart/payment-success&apmCallbackFailUrl=' + globals.frontDomain + '/' + this.showLang +
                        '/cart?paymentStatus=failed';
                }
                this.cartService.sendPayment(globals.appDomain + '/payments/purchaseOrder/' +
                    this.user.memberId
                    + '/purchaseOrder_scratchCheckout.json', body)
                    .then(output => {
                        if (output === 'resolved') {
                            const result = this.cartService.paymentResult;
                            this.closeModal();
                            if (result.message.ErrorID === undefined) {
                                this.prepareOrder();
                                this.errorDefault = false;
                                this.error42 = false;
                                this.error50 = false;
                                this.error69 = false;
                                this.user = JSON.parse(localStorage.getItem('playerDetails'));
                                if (paymentMethod === 'balance') {
                                    this.user.TotalBalance = this.user.TotalBalance - result.message.Price;
                                    this.subscriptionsService.updateBalance(this.user.TotalBalance);
                                } else {
                                    this.userService.getUserDetails(this.userService.userData.sessionId, this.userService.userData.memberId, false).then(itsoutput => {
                                        if (itsoutput === 'user') {
                                            this.userService.getUser();
                                            this.subscriptionsService.updateBalance(this.userService.userData.TotalBalance);
                                        }
                                    });
                                }
                                localStorage.setItem('playerDetails', JSON.stringify(this.user));
                                localStorage.setItem('affiliateData', JSON.stringify(result.message));
                                this.subscriptionsService.emitFirstTimeAffiliate(true);
                                localStorage.setItem('createAffiliateLink', 'true');
                                if (result.message.RedirectURL !== undefined) {
                                    localStorage.setItem('update_data', 'true');
                                    window.location.href = result.message.RedirectURL;
                                    setTimeout(() => {
                                        this.isLoadingButton = false;
                                    }, 1000);
                                } else if (result.message.Post.actionUrl && result.message.Post.paRequest) {
                                    const body3d = {
                                        PaReq: result.message.Post.paRequest,
                                        TermUrl: globals.appDomain + '/3dflow?paymentStatusCheck=true&transactionId=' + result.message.Post.transactionId
                                    };
                                    this.send3dPost(body3d, result.message.Post.actionUrl);
                                } else {
                                    this.isLoadingButton = false;
                                    this.paymentModal = !this.paymentModal;
                                    if (!this.paymentModal) {
                                        this.endMiniCheckout();
                                    }
                                    this.renderer.removeClass(document.body, 'modal-open');
                                    localStorage.removeItem('cart');
                                    this.successPayment = !this.successPayment;
                                    this.paymentModal = !this.paymentModal;
                                    if (!this.paymentModal) {
                                        this.endMiniCheckout();
                                    }
                                    this.updateCartLength();
                                    this.subscriptionsService.emitRefreshEntries(true);
                                    this.subscriptionsService.updateMyScratchSection(true);
                                    this.subscriptionsService.emitToggleContent(true);
                                    localStorage.removeItem('success3d');
                                    localStorage.removeItem('fail3d');
                                    // this.router.navigate(['/' + this.showLang, 'cart', 'payment-success']);
                                    window.scrollTo(0, 0);
                                }
                                this.userService.getUserDetails(this.userService.userData.sessionId, this.userService.userData.memberId, false).then(itsoutput => {
                                    if (itsoutput === 'user') {
                                        this.userService.getUser();
                                    }
                                });
                            } else {
                                this.isLoadingButton = false;
                                this.errorParams = result.message.ErrorParams;
                                this.paymentFailed = true;
                                this.paymentModal = false;
                                this.endMiniCheckout();
                                localStorage.removeItem('success3d');
                                localStorage.removeItem('fail3d');
                                if (result.message.ErrorID === '042') {
                                    this.error42 = true;
                                    this.errorParams = result.message.ErrorParams;
                                    this.errorReason = result.message.ErrorReason;
                                } else if (result.message.ErrorID === '050') {
                                    this.error50 = true;
                                    this.errorParams = result.message.ErrorParams;
                                    this.errorReason = result.message.ErrorReason;
                                } else if (result.message.ErrorID === '068') {
                                    this.error68 = true;
                                } else if (result.message.ErrorID === '081') {
                                    this.error81 = true;
                                    this.errorParams = result.message.ErrorParams;
                                } else if (result.message.ErrorID === '075') {
                                    this.error75 = true;
                                } else if (result.message.ErrorID === '074') {
                                    this.error74 = true;
                                } else if (result.message.ErrorID === '069') {
                                    this.error69 = true;
                                } else if (result.message.ErrorID === '090') {
                                    this.error90 = true;
                                } else if (result.message.ErrorID === '094') {
                                    this.error94 = true;
                                } else if (result.message.ErrorID === '095') {
                                    this.error95 = true;
                                    this.errorDefault = true;
                                } else if (result.message.ErrorID === '10008') {
                                    this.error10008 = true;
                                } else {
                                    this.errorDefault = true;
                                }
                            }
                        }
                    });
            } else {
                this.closeModal();
            }
        });
    }

    prepareOrder() {
        const sendData = {};
        sendData['sessionId'] = this.user.sessionId;

        this.lotteryService
            .postData(
                globals.appDomain + '/cart/get/' + this.user.MemberID + '/cartGet.json', this.lotteryService.getFormUrlEncoded(sendData))
            .subscribe(
                data => {
                    this.cartItems = data.message.Packages;
                    if (!this.cartItems || !this.cartItems.length) {
                        this.isEmptyCart = true;
                    }
                    if (data.message.Packages !== undefined) {
                        localStorage.setItem('cart', JSON.stringify(data.message.Packages));
                        this.mapCart(this.cartItems);
                    } else {
                        this.sendFromLocal();
                    }
                    this.rendered = true;
                    this.updateCartLength();
                }
            );
    }

    mapCart(jsonCart) {
        if (this.firstTime === true) {
            this.checkDiscount = false;
        } else {
            this.checkDiscount = true;
        }
        let totalPrice = 0;
        let originalPrice = 0;
        jsonCart.forEach((element, index) => {
            element.Items[0].position = index;
            element.Items = Object.keys(element.Items).map(key => element.Items[key]);
            totalPrice += +element.PackagePrice;
            originalPrice += +element.OriginPrice;
            if (element.Items[0].ParticipationDays) {
                element.Items[0].weeklyDraws = Object.keys(element.Items[0].ParticipationDays).length;
            }
        });
        this.originalPrice = +originalPrice;
        this.originalPrice = (+this.originalPrice).toFixed(2);
        this.totalPrice = (+totalPrice).toFixed(2);
        if (this.discountAmount === undefined) {
            this.discountAmount = 0;
        }
        if (this.discount === undefined) {
            this.discount = 0;
        }
        if (this.promoPercent === undefined) {
            this.discountAmount = 0;
        }
        if (this.discountAmount !== 0) {
            this.discountAmount = (this.totalPrice * this.promoPercent) / 100;
            this.discountToShow = (+this.discount + +this.discountAmount).toFixed(2);
        } else {
            this.discountToShow = (this.originalPrice - this.totalPrice).toFixed(2);
        }
        if (this.checkDiscount === true) {
            if (jsonCart.length !== 1) {
                if (+this.totalPrice === 0.00) {
                    this.discountToShow = 0.00;
                }
            }
        }
        if (isNaN(this.discountToShow)) {
            this.discountToShow = 0.00;
            this.discountToShow = this.discountToShow.toFixed(2);
        }
        this.discountPrice = this.recalculatePriceForBalance((+this.originalPrice - +this.discountToShow).toFixed(2), 'discount');
        this.totalPrice = this.recalculatePriceForBalance((+this.totalPrice).toFixed(2), 'total');
        if (+this.discountToShow === 0) {
            this.showDiscount = false;
        } else {
            this.showDiscount = true;
        }
        this.discount = (this.originalPrice - this.totalPrice).toFixed(2);
        if (+this.discountPrice === 0.00) {
            this.claim = true;
        }
        this.firstTime = false;
        this.updateCartLength();
        const totalBalance = this.myBalance ? this.myBalance * 1 : this.user.TotalBalance * 1;
        this.balanceChecker();
    }

    sendFromLocal() {
        const dataString = localStorage.getItem('playerDetails');
        let storedCart = localStorage.getItem('cart');
        if (storedCart === '[]' || !storedCart) {
            localStorage.removeItem('cart');
            storedCart = null;
            this.cartItems = null;
            if (!this.cartItems || !this.cartItems.length) {
                setTimeout(() => {
                    this.isEmptyCart = true;
                }, 500);
            }
        } else if (storedCart) {
            let jsonCart = JSON.parse(storedCart);
            jsonCart = Array.from(jsonCart);
            this.cartItems = jsonCart;
        }
        const dataJson = JSON.parse(dataString);
        this.user = dataJson;
        let cartToSend = '';
        let memberId = 0;
        if (dataString === null) {
            cartToSend += '&sessionId=0';
            memberId = 0;
        } else {
            cartToSend += '&sessionId=' + this.user.sessionId;
            memberId = this.user.memberId;
        }
        cartToSend += '&sessionCart=1';
        if (this.cartItems !== null) {
            for (const x in this.cartItems) {
                if (this.cartItems[x].Items) {
                    cartToSend += '&packageId[' + x + ']=' + this.cartItems[x].PackageID;
                    cartToSend += '&lotteryId[' + x + ']=' + this.cartItems[x].Items[0].LotteryID;
                    cartToSend += '&billingPeriod[' + x + ']=1';
                    cartToSend += '&isSubscription[' + x + ']=0';
                    cartToSend += '&drawCount[' + x + ']=' + this.cartItems[x].DrawCount;
                    if (this.cartItems[x].TicketsCount) {
                        cartToSend += '&TicketsCount[' + x + ']=' + this.cartItems[x].TicketsCount;
                    }
                    for (const i of Object.keys(this.cartItems[x].Items)) {
                        if (this.cartItems[x].Items[i].PickedNumbers) {
                            for (const z of Object.keys(this.cartItems[x].Items[i].PickedNumbers)) {
                                cartToSend
                                    += '&base[' + x + '][]='
                                    + JSON.stringify(this.cartItems[x].Items[i].PickedNumbers[z].BasePick);
                                cartToSend
                                    += '&extra[' + x + '][]='
                                    + JSON.stringify(this.cartItems[x].Items[i].PickedNumbers[z].ExtraPick);
                            }
                        }
                    }
                }
            }
        }
        const newCart = localStorage.getItem('cart');
        if (newCart !== undefined) {
            cartToSend += '&orderData=[]';
        }
        cartToSend += '&currency=' + this.currency;
        this.lotteryService
            .postData(globals.appDomain + '/cart/addSingleTicket/' +
                memberId + '/cartAddSingleTicket.json', cartToSend)
            .subscribe(
                response => {
                    if (response.addCartMessage.Status === 'OK') {
                        localStorage.removeItem('cart');
                        this.discount = 0.00;
                        this.totalPrice = 0.00;
                        this.discountAmount = 0.00;
                        this.discountToShow = 0.00;
                        this.originalPrice = 0.00;
                        this.discountPrice = false;
                    } else {
                        if (response.addCartMessage.ErrorID === '075') {
                            this.cartItems.forEach((element, key) => {
                                if (element.PackageID === response.addCartMessage.ErrorParams) {
                                    this.cartItems.splice(key, 1);
                                    localStorage.setItem('cart', JSON.stringify(this.cartItems));
                                    this.updateCartLength();
                                    this.prepareCart();
                                }
                            });
                        } else {
                            localStorage.setItem('cart', JSON.stringify(response.addCartMessage.Cart.Packages));
                            this.cartItems = response.addCartMessage.Cart.Packages;
                            this.updateCartLength();
                            this.mapCart(this.cartItems);
                        }
                    }
                    if (response.addCartMessage.ErrorID !== undefined && response.message.ErrorID === '074') {
                        this.error74 = true;
                        this.paymentFailed = true;
                        this.paymentModal = false;
                        this.endMiniCheckout();
                        this.modalSize = 'modal-md';
                    } else if (response.addCartMessage.ErrorID !== undefined) {
                        this.errorDefault = true;
                    }
                    this.updateCartLength();
                }
            );
    }

    updateCartLength(): void {
        let cart = localStorage.getItem('cart');
        cart = JSON.parse(cart);
        if (cart) {
            if (cart.length > 0) {
                this.subscriptionsService.updateCart(cart.length);
                // this.router.navigate(['/cart']);
            }
        } else {
            this.subscriptionsService.updateCart(0);
        }
    }

    prepareCart() {
        const dataString = localStorage.getItem('playerDetails');
        let storedCart = localStorage.getItem('cart');

        if (storedCart) {
            const dataCart = JSON.parse(storedCart);
            for (let i = 0; i < dataCart.length; i++) {
                if (dataCart[i] === null) {
                    localStorage.removeItem('cart');
                    storedCart = null;
                    this.updateTheCart = this.subscriptionsService.getCartItemsUpdate().subscribe(cart2 => {
                        this.cartItems = cart2;
                        localStorage.setItem('cart', JSON.stringify(this.cartItems));
                    });
                }
            }
        }

        if (storedCart === '[]') {
            localStorage.removeItem('cart');
            storedCart = null;
        }
        if (dataString !== null) {
            const dataJson = JSON.parse(dataString);
            this.user = dataJson;
            const language = localStorage.getItem('pageLanguage');
            this.showSelected = false;
            this.showApply = false;
            this.showNotValid = false;
            this.prepareOrder();
        } else if (storedCart !== null && storedCart !== undefined && dataString === null) {
            this.sendFromLocal();
        } else {
            this.discount = 0.00;
            this.totalPrice = 0.00;
            this.discountAmount = 0.00;
            this.discountToShow = 0.00;
            this.originalPrice = 0.00;
            this.discountPrice = false;
        }
        let cart = localStorage.getItem('cart');
        cart = JSON.parse(cart);
        if (cart) {
            if (cart.length > 0) {
                this.isEmptyCart = false;
                this.subscriptionsService.updateCart(cart.length);
            }
        } else {
            this.subscriptionsService.updateCart(0);
            this.isEmptyCart = true;
        }
    }

    removeScratch(event, val) {
        event.preventDefault();
        this.toRemove = val;
    }

    confirmRemove(event) {
        event.preventDefault();
        this.cartItems = JSON.parse(localStorage.getItem('cart'));
        this.cartItems.splice(this.toRemove, 1);
        this.myScratch = this.cartItems;
        this.renderer.removeClass(document.body, 'modal-open');
        this.removeFromCart = false;
        localStorage.setItem('cart', JSON.stringify(this.cartItems));
        this.sendFromLocal();
        if (this.cartItems === null) {
            this.closeModal();
        }
    }

    cancelRemove() {
        this.removeFromCart = !this.removeFromCart;
        this.renderer.removeClass(document.body, 'modal-open');
    }

    closePaymentModal() {
        this.subscriptionsService.updateMyScratchSection(true);
        this.successPayment = !this.successPayment;
        this.renderer.removeClass(document.body, 'modal-open');
        this.subscriptionsService.emitToggleContent(true);
        this.router.navigate(['/' + this.showLang, 'scratchcards']);
        this.endMiniCheckout();
    }

    resendCart(val) {
        const playerShares = localStorage.getItem('playerShares') === '1' ? '&playerShares=' + 1 : '';
        const user = localStorage.getItem('playerDetails');
        const userJson = JSON.parse(user);
        let sessionId = '';
        let memberId = 0;
        if (userJson === null) {
            sessionId = '';
            memberId = 0;
        } else {
            sessionId = this.user.sessionId;
            memberId = this.user.memberId;
        }
        const cart = localStorage.getItem('cart');
        const jsonCart = JSON.parse(cart);
        if (jsonCart) {
            this.cartItems = jsonCart;
            let cartToSend = val;
            cartToSend += '&sessionId=' + sessionId;
            cartToSend += '&sessionCart=1' + playerShares;
            for (const x of Object.keys(this.cartItems)) {
                if (val) {
                    const y = +x;
                    this.n = y + 1;
                } else {
                    this.n = x;
                }
                cartToSend += '&packageId[' + this.n + ']=' + this.cartItems[x].PackageID;
                cartToSend += '&lotteryId[' + this.n + ']=' + this.cartItems[x].Items[0].LotteryID;
                cartToSend += '&billingPeriod[' + this.n + ']=1';
                cartToSend += '&isSubscription[' + this.n + ']=0';
                cartToSend += '&drawCount[' + this.n + ']=' + this.cartItems[x].DrawCount;
                cartToSend += '&couponCode=' + val.promoCodeInput;
                if (this.cartItems[x].TicketsCount) {
                    cartToSend += '&TicketsCount[' + this.n + ']=' + this.cartItems[x].TicketsCount;
                }
                for (const i of Object.keys(this.cartItems[x].Items)) {
                    if (this.cartItems[x].Items[i].PickedNumbers) {
                        for (const z of Object.keys(this.cartItems[x].Items[i].PickedNumbers)) {
                            cartToSend
                                += '&base[' + this.n + '][]='
                                + JSON.stringify(this.cartItems[x].Items[i].PickedNumbers[z].BasePick);
                            cartToSend
                                += '&extra[' + this.n + '][]='
                                + JSON.stringify(this.cartItems[x].Items[i].PickedNumbers[z].ExtraPick);
                        }
                    }
                }
            }
            return cartToSend;
        } else {
            if (sessionId) {
                return val + '&sessionId=' + sessionId + '&sessionCart=1';
            } else {
                return val + '&sessionId=' + '&sessionCart=1';
            }

        }
    }

    goToRegistration() {
        localStorage.setItem('isOpenRegister', 'true');
        this.renderer.addClass(document.body, 'modal-open-register');
        setTimeout(() => {
            localStorage.removeItem('isOpenRegister');
        }, 50);
        this.subscriptionsService.emitRegister(true);
    }

    runAddPM() {
        this.subscriptionsService.miniCheckoutEnabled = true;
        this.renderer.removeClass(document.body, 'modal-open');
        this.goToRegistration();
        this.subscriptionsService.onlyPmStep(true);
        localStorage.setItem('waitingForDone', 'minicheckout');
        this.subscriptionsService.updateMiniCheckoutAddPM(true);
    }

    tryDifferenPaymentMethod() {
        this.paymentFailed = false;
        this.paymentModal = true;
        if (this.paymentMethods.length === 1) {
            this.runAddPM();
        } else if (this.selected_method_show_name) {
            this.selected_method_show_name = this.paymentMethods.length === this.paymentMethods.findIndex(
                el => el.selectDisplayName === this.chosenOptionName) + 1 ?
                this.paymentMethods[0] :
                this.paymentMethods[this.paymentMethods.findIndex(el => el.selectDisplayName === this.chosenOptionName) + 1];
            this.chosenOptionName = this.selected_method_show_name.selectDisplayName;
            if (this.selected_method_show_name.selectDisplayName !== 'balance') {
                this.selected_method = this.selected_method_show_name.selectValue;
                this.chosenOption = this.selected_method_show_name.selectValue;
            } else {
                this.selected_method = 'balance';
                this.chosenOption = 'balance';
                this.balancePay = true;
            }
            this.isLoadingButton = false;
        }
    }

    endMiniCheckout() {
        this.subscriptionsService.miniCheckoutEnabled = false;
    }

    ngOnDestroy() {
        if (this.changedCurrency) {
            this.changedCurrency.unsubscribe();
        }
        if (this.getPaymentMethodsSub) {
            this.getPaymentMethodsSub.unsubscribe();
        }
    }

    recalculatePriceForBalance(payable, inCase) {
        this.userService.getUser();
        const user = localStorage.getItem('playerDetails');
        let userObj;
        if (user) {
            userObj = JSON.parse(user);
        }
        if (user && userObj && +userObj.RealBalance > 0) {
            if (+userObj.RealBalance > payable) {
                if (inCase === 'total') {
                    this.minusBalanceValue_forTotal = payable;
                } else if (inCase === 'discount') {
                    this.minusBalanceValue_forDiscount = payable;
                }
                payable = 0.00;
            } else {
                if (inCase === 'total') {
                    this.minusBalanceValue_forTotal = +userObj.RealBalance;
                } else if (inCase === 'discount') {
                    this.minusBalanceValue_forDiscount = +userObj.RealBalance;
                }
                payable = payable - +userObj.RealBalance;
            }
            this.subscriptionsService.emitSendPayment('refreshButton');
            return payable;
        } else {
            this.minusBalanceValue_forTotal = 0;
            this.minusBalanceValue_forDiscount = 0;
            this.subscriptionsService.emitSendPayment('refreshButton');
            return payable;
        }
    }

    send3dPost(obj, url) {
        const form3d = this.renderer.createElement('form');
        this.renderer.setProperty(form3d, 'method', 'POST');
        this.renderer.setProperty(form3d, 'action', url);
        const paRequest = this.renderer.createElement('input');
        this.renderer.setProperty(paRequest, 'type', 'hidden');
        this.renderer.setProperty(paRequest, 'name', 'PaReq');
        this.renderer.setProperty(paRequest, 'value', obj.PaReq);
        const termURL = this.renderer.createElement('input');
        this.renderer.setProperty(termURL, 'type', 'hidden');
        this.renderer.setProperty(termURL, 'name', 'TermUrl');
        this.renderer.setProperty(termURL, 'value', obj.TermUrl);
        this.renderer.appendChild(form3d, paRequest);
        this.renderer.appendChild(form3d, termURL);
        this.renderer.appendChild(document.body, form3d);
        form3d.submit();
    }

    cleanCart() {
        localStorage.removeItem('cart');
        this.cartService.cleanBox();
        this.subscriptionsService.updateCart(0);
        this.cartItems = null;
        this.isEmptyCart = true;
        this.paystackSupport.generateReferenceId();
    }

    paymentCancel() {
        this.paystackSupport.paymentCancel();
        this.paymentModal = true;
        this.paystackSupport.usePaystack = false;
        this.prepareOrder();
        if (!this.paymentSuccess) {
        }
    }

    paymentDone($event) {
        this.paystackSupport.paymentDone($event);
        this.paymentModal = false;
        this.paymentSuccess = true;

        const body = 'TransactionId=' + $event.reference;
        this.lotteryService.postData(globals.appDomain + '/payments/getTransactionStatus/status_paystack.json',
            body).subscribe(response => {
            if (response && response.message.transactionStatus === 'success') {
                this.successPayment = true;
                this.cleanCart();
                this.usePaystack = false;
                this.prepareOrder();
            } else if (response && response.message.transactionStatus === 'pending') {
                // this.router.navigate(['/' + this.showLang, 'cart', 'payment-pending'],
                //     { queryParams: { paymentStatusCheck: 'true', transactionId: $event.reference}});
                this.router.navigate(['/' + this.showLang, 'cart', 'payment-pending']);
            } else {
                this.paymentCancel();
            }
        });
    }
}
